import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { QIInput, QIButton } from "../../../components";
import { useResetPasswordMutation } from "../service";
import { resetPasswordSchema } from "../validations";
import { ConfirmationModal } from "../Shared/ConfirmationModal";
import sprite from "../../../assets/icons.svg";

export const ResetPasswordOtp = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues] = useState({
    password: "",
    password_confirmation: "",
    id,
  });

  const [errorModal, setShowErrorModal] = useState({
    msg: "",
    show: false,
    type: "",
  });

  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const [create, { isSuccess, isError }] = useResetPasswordMutation();

  const onSubmit = (formData) => {
    create({ formData });
  };

  useEffect(() => {
    if (isSuccess) {
      setShowErrorModal({
        msg: "Successfully updated password!",
        show: true,
        type: "success",
        headerText: "Reset Email Success!",
      });
    }
    if (isError) {
      setShowErrorModal({
        msg: "Token expired or Something went wrong. Try again.",
        show: true,
        type: "error",
        headerText: "Reset Email Alert!",
      });
    }
  }, [isSuccess, isError]);

  const closeWarningModal = () => {
    if (errorModal.type === "success") {
      navigate("/");
    }
    setShowErrorModal({
      msg: "",
      show: false,
      type: "",
    });
  };

  return (
    <div className="login-layout">
      <header className="qi-header">
        <h3 className="qi-header_title text-center">
          <strong>Fleet Mobility Data Platform</strong>
        </h3>
      </header>

      <div className="login-form-container">
        <h1 className="qi-header_title mb-4">
          <strong>Set New Password</strong>
        </h1>
        <QIInput
          label="Password"
          {...formik.getFieldProps("password")}
          error={formik.touched.password && formik.errors.password}
          type="password"
        />
        <QIInput
          label="Confirm Password"
          {...formik.getFieldProps("password_confirmation")}
          type="password"
          error={formik.touched.password_confirmation && formik.errors.password_confirmation}
        />

        <QIButton
          className="primary w-full mt-4"
          icon={{ src: `${sprite}#next`, className: "next-icon" }}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Send
        </QIButton>

        <div className="text-center mt-10">
          <a href="/login">Back to login</a>
        </div>
      </div>
      {errorModal.show && (
        <ConfirmationModal
          onOkay={() => {
            closeWarningModal();
          }}
          show={errorModal.show}
          headerText={errorModal.headerText}
        >
          <p
            className={`text-center mt-10 ${
              errorModal.type === "error" ? "configurations-error" : ""
            }`}
          >
            {errorModal.msg}
          </p>
        </ConfirmationModal>
      )}
      <footer className="qi-footer text-center">
        <p className="">
          Copyright &copy;
          {new Date().getFullYear()} Fleet Management. All rights reserved.
        </p>
      </footer>
    </div>
  );
};
